var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"id":"upbutton","src":"static/images/zd.jpg"},on:{"click":_vm.backTop}}),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/Admissionnotice', query: { act: 'first' } },"id":"scan"}},[_vm._v("会员入口")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d6c60e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Suspend.vue
// module id = null
// module chunks = 